import './navbar.css'
import { ReactComponent as Flogo } from '../icons/f-logo.svg';
import { ReactComponent as Ellipsis } from '../icons/ellipsis-solid.svg';
import { ReactComponent as Messenger } from '../icons/facebook-messenger.svg';

import { ReactComponent as Home } from '../icons/house-chimney-solid.svg';
import { ReactComponent as Usergroup } from '../icons/user-group-solid.svg';
import { ReactComponent as Bell } from '../icons/bell-solid.svg';
import { ReactComponent as Downarrow } from '../icons/caret-down-solid.svg';

export default function Navbar() {
  return (
    <div className='fbnavbar bor'>
        <div className='plogo'>
            <Flogo fill='#ffffff'/>
        </div>
        <div className='psearch'>
            <input type="text" placeholder='Search Facebook...'/>
        </div>
    </div>
  )
}

export function Navbar1(){
    return (
        <div className='fbnavbar bor'>

          <div className='bolnahalkehalke'>
              <div className='pppicons'>
                <Home fill='#adb6df'/>
                <Usergroup fill='#adb6df' />
                <Bell fill='#adb6df' />
              </div>
              <div className='ppprofile'>
                <div className='profileimg'>
                  <img src='https://besthqwallpapers.com/Uploads/19-8-2018/62142/thumb2-chris-pratt-hollywood-star-american-actor-photoshoot-portrait.jpg' alt='profile'/>
                </div>
                <Downarrow fill='#adb6df' />
              </div>
          </div>

        </div>
      )
}

export function Navbar2(){
    return (
        <div className='fbnavbar ruperivalutyena bor'>
          <div className='pnav-messenger-name'>
            <Messenger fill='#ffffff'/>
            Messenger
          </div>
          <Ellipsis fill='#ffffff'/>
        </div>
      )
}
